import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { Sidebar } from '../../core/services/sidebar';
import { DataTable } from "../../shared/components/data-table/data-table";
import { FilterOptions, ModalOptions } from '../../shared/utils/types';
import { BaseModal } from '../../shared/components/modals/base-modal/base-modal';
import { Modal } from '../../core/services/modal';
import { RejectUserAccount } from '../../shared/components/modals/reject-user-account/reject-user-account';


@Component({
  selector: 'app-activity-status',
  imports: [DataTable, CommonModule, TranslatePipe],
  templateUrl: './activity-status.html',
  styleUrl: './activity-status.css'
})
export class ActivityStatus {
  total = 0;
  page = 1;
  userType: 'checker' | 'maker' | 'admin' = 'maker';
  gridTemplateColumns = 'repeat(16, minmax(0, 1fr))';

  defaultFilter: FilterOptions = [
    {
      category: 'ACTIVITY_STATUS.SORT_BY',
      type: 'radio',
      options: [
        { label: 'ACTIVITY_STATUS.LATEST', key: 'latest', checked: true, isDefault: true },
        { label: 'ACTIVITY_STATUS.OLDEST', key: 'oldest', checked: false }
      ]
    },
    {
      category: 'ACTIVITY_STATUS.STATUS',
      type: 'check',
      options: [
        { label: 'ACTIVITY_STATUS.PENDING_APPROVAL', key: 'pending-approval', checked: true },
        { label: 'ACTIVITY_STATUS.ACCEPTED', key: 'accepted', checked: true },
        { label: 'ACTIVITY_STATUS.REJECTED', key: 'rejected', checked: true }
      ]
    }
  ];

  filterOptions: FilterOptions = JSON.parse(JSON.stringify(this.defaultFilter));

  columns = [
    { key: 'activity', label: 'ACTIVITY_STATUS.ACTIVITY', gridClass: 'xl:col-span-3 col-span-4' },
    { key: 'amount', label: 'ACTIVITY_STATUS.AMOUNT', gridClass: 'col-span-3' },
    { key: 'ref', label: 'ACTIVITY_STATUS.REF_NO', gridClass: 'xl:col-span-3 col-span-2' },
    { key: 'date', label: 'ACTIVITY_STATUS.DATE', gridClass: 'xl:col-span-3 col-span-2' },
    { key: 'status', label: 'ACTIVITY_STATUS.STATUS', gridClass: 'xl:col-span-3 col-span-4' },
    { key: 'actions', label: ' ', gridClass: 'col-span-1' }
  ];

  //Note: All activity that is tagged as Pending Approval will have approve, reject and view details. Please note that approve and reject only for checker
  //for maker, they can only see view details
  transactions: any[] = [{
    activity: 'CliQ - Ahmad Zain',
    amount: '-220.000',
    ref: '34354532',
    date: '15 Oct 2025',
    status: 'Pending approval',
    actions: [
      { label: 'ACTIVITY_STATUS.APPROVE', action: () => { this.acceptRejectModal('approve') } },
      { label: 'ACTIVITY_STATUS.REJECT', action: () => { this.acceptRejectModal('reject') } },
      { label: 'ACTIVITY_STATUS.VIEW_DETAILS', action: () => { this.router.navigate(['/user-management/create-user'],) } }
    ]
  },
  {
    activity: 'Bill payment - Jordan electricity',
    amount: '+250.000',
    ref: '34354532',
    date: '15 Oct 2025',
    status: 'Accepted',
    actions: [
      { label: 'ACTIVITY_STATUS.APPROVE', action: () => { this.acceptRejectModal('approve') } },
      { label: 'ACTIVITY_STATUS.REJECT', action: () => { this.acceptRejectModal('reject') } },
      { label: 'ACTIVITY_STATUS.VIEW_DETAILS', action: () => { this.router.navigate(['user-management/create-user'],) } }
    ]
  },
  {
    activity: 'Portal management - add user',
    amount: '-180.000',
    ref: '34354532',
    date: '15 Oct 2025',
    status: 'Pending approval',
    actions: [
      { label: 'ACTIVITY_STATUS.APPROVE', action: () => { this.acceptRejectModal('approve') } },
      { label: 'ACTIVITY_STATUS.REJECT', action: () => { this.acceptRejectModal('reject') } },
      { label: 'ACTIVITY_STATUS.VIEW_DETAILS', action: () => { this.router.navigate(['user-management/create-user'],) } }
    ]
  },
  {
    activity: 'CliQ - Abdoullah Jabor',
    amount: 'N/A',
    ref: '34354532',
    date: '18 Dec 2024',
    status: 'Rejected',
    actions: [
      { label: 'ACTIVITY_STATUS.APPROVE', action: () => { this.acceptRejectModal('approve') } },
      { label: 'ACTIVITY_STATUS.REJECT', action: () => { this.acceptRejectModal('reject') } },
      { label: 'ACTIVITY_STATUS.VIEW_DETAILS', action: () => { this.router.navigate(['user-management/create-user'],) } }
    ]
  },
  {
    activity: 'Cash pull',
    amount: '-180.000',
    ref: '34354532',
    date: '15 Oct 2025',
    status: 'Accepted',
    actions: [
      { label: 'ACTIVITY_STATUS.APPROVE', action: () => { this.acceptRejectModal('approve') } },
      { label: 'ACTIVITY_STATUS.REJECT', action: () => { this.acceptRejectModal('reject') } },
      { label: 'ACTIVITY_STATUS.VIEW_DETAILS', action: () => { this.router.navigate(['user-management/create-user'],) } }
    ]
  },
  {
    activity: 'Cash pull',
    amount: '-180.000',
    ref: '34354532',
    date: '15 Oct 2025',
    status: 'Rejected',
    actions: [
      { label: 'ACTIVITY_STATUS.APPROVE', action: () => { this.acceptRejectModal('approve') } },
      { label: 'ACTIVITY_STATUS.REJECT', action: () => { this.acceptRejectModal('reject') } },
      { label: 'ACTIVITY_STATUS.VIEW_DETAILS', action: () => { this.router.navigate(['user-management/create-user'],) } }
    ]
  }];

  constructor(
    private sidebarService: Sidebar,
    private modalService: Modal,
    private router: Router
  ) { }

  ngOnInit() {
    this.sidebarService.setToDefault();

    const storedUserType = localStorage.getItem('userRole');

    if (storedUserType === 'checker' || storedUserType === 'maker' || storedUserType === 'admin') {
      this.userType = storedUserType;
    }
  }

  onSearch(value: string) {
    this.page = 1;
    this.fetchData(value);
  }

  loadPage(p: number) {
    this.page = p;
    this.fetchData();
  }

  fetchData(search: string = '') {
    // API call...
  }

  onFilterApply(updatedFilters: FilterOptions) {
    this.filterOptions = JSON.parse(JSON.stringify(updatedFilters));

    // console.log(this.filterOptions, "new applied filters ")
    this.page = 1;             // reset to first page
    this.fetchData();          // re-call API
  }

  onFilterReset() {
    this.filterOptions = JSON.parse(JSON.stringify(this.defaultFilter));
    // console.log(this.filterOptions, "reset")
    this.page = 1;
    this.fetchData();
  }

  acceptRejectModal(type: 'approve' | 'reject') {
    const title = type === 'approve' ? 'ACTIVITY_STATUS.APPROVE_USER_CONFIRM' : 'ACTIVITY_STATUS.REJECT_USER_CONFIRM';
    const msg = type === 'approve' ? 'ACTIVITY_STATUS.APPROVAL_NOTE' : ''
    const btn = type === 'approve' ? 'ACTIVITY_STATUS.APPROVE_NOW' : 'ACTIVITY_STATUS.CONTINUE';

    const baseModalOptions: ModalOptions = {
      backdropClosable: false,
      showCancelButton: true,
      showConfirmButton: true,
      textConfrimButton: btn,
      textCancelButton: 'ACCOUNTS.GO_BACK',
      size: 'lg',
      headerIconPath: 'assets/icons/info-yellow.svg',
      linkText: 'ACCOUNTS.VIEW_REQUEST_DETAILS',
      linkAction: () => {
        this.router.navigate(['/user-management/create-user']);
        this.modalService.close();
      },
      title: title,
      message: msg,
      onConfirm: () => {
        if (type === 'reject') {
          this.rejectUserAccount();
        } else {
          this.router.navigate(['/user-management'], { state: { payload: { showUserAccountStatus: true, title: 'ACTIVITY_STATUS.APPROVAL_SUCCESS_TITLE', subTitle: 'ACTIVITY_STATUS.APPROVAL_SUCCESS_DESC' } } });
          this.modalService.close();
        }

      },
      onCancel: () => {
        this.modalService.close();
      }
    };

    this.modalService.open(BaseModal, baseModalOptions);
  }

  rejectUserAccount() {
    const modalOptions: ModalOptions = {
      backdropClosable: false,
      showCancelButton: false,
    };

    this.modalService.open(RejectUserAccount, modalOptions);
  }
}
